import React from "react";
import { Button } from "@/components/ui/button";
import { Clock, Sun, Moon, Sparkles, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import NotificationCenter from "@/components/NotificationCenter";

export const DesktopTopBar = ({
  collapsed, toggleCollapsed, theme, toggleTheme,
  currentTime, formatDate, formatTime, setShowWhatsNew, hasNewUpdates,
}) => (
  <div className="hidden lg:flex items-center justify-between px-8 py-4 border-b border-border bg-card/50">
    {/* Live Date/Time - Desktop */}
    <div className="flex items-center gap-3 text-sm" data-testid="live-datetime-desktop">
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleCollapsed}
        className="h-9 w-9 -ml-2"
        data-testid="sidebar-collapse-toggle"
        title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {collapsed ? <PanelLeftOpen className="h-5 w-5" /> : <PanelLeftClose className="h-5 w-5" />}
      </Button>
      <Clock className="h-4 w-4 text-muted-foreground" />
      <div className="flex items-center gap-2">
        <span className="text-muted-foreground">{formatDate(currentTime)}</span>
        <span className="text-muted-foreground">•</span>
        <span className="font-medium text-foreground tabular-nums">{formatTime(currentTime)}</span>
      </div>
    </div>
    <div className="flex items-center gap-2">
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={toggleTheme}
        className="h-9 w-9"
        data-testid="theme-toggle-desktop"
      >
        {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 relative"
        onClick={() => setShowWhatsNew(true)}
        data-testid="whats-new-btn"
      >
        <Sparkles className="h-5 w-5" />
        {hasNewUpdates && <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-brand-500" />}
      </Button>
      <NotificationCenter />
    </div>
  </div>
);
